import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { requiredValidator } from "../../Components/FormValidations";
import FormError from "../../Components/FormError";
import { convertTimeToAMPM, generalGetFunction, generalPostFunction, getFinalTime } from "../../Globals/globalFunctions";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { cardArray, gameCollectionArray, gamePayRates, gamePorts } from "../../Globals/globalMetaData";
import { useSelector, useDispatch } from "react-redux";
import { gameSettingsRefresh } from "../../Redux/gameSettingsSlice";
import { SvgIcon } from "../../Components/SvgIcons";

function SetGameResult() {
	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
		watch,
	} = useForm();

	const dispatch = useDispatch();
	const [gameResultTime, setGameResultTime] = useState("");
	const [currentGameId, setCurrentGameId] = useState("");
	const [refresh, setRefresh] = useState(0);
	const [loading, setLoading] = useState(false);
	const [selectedCard, setSelectedCard] = useState("");
	const [allBetData, setAllBetData] = useState([]);
	const [selectedMultiplier, setSelectedMultiplier] = useState(0);
	const allPlayerBet = useSelector((state) => state.allPlayers.allPlayerBet);

	// Timer States
	const [gameTime, setGameTime] = useState(0);
	const [isTimerActive, setIsTimerActive] = useState(true);
	const [canBet, setCanBet] = useState(true);

	const locationState = useLocation();

	const handleSetResult = async (data) => {
		const payload = {
			manualresult: selectedCard,
		};
		try {
			const port = gamePorts[locationState.state.value];

			const response = await generalPostFunction("/setmanualresult", payload, port);
			if (response.message.includes("updated")) {
				toast.success("Result updated successfully!");
				reset();
			}
		} catch (err) {
			console.log(err);
		}
	};

	const getCurrentGameTime = async () => {
		try {
			const port = gamePorts[locationState.state.value];

			if (!port) {
				console.log("Invalid game name selected.");
				return;
			}

			const response = await generalGetFunction("/timeleft", port);

			if (response && response?.time && response?.gameid) {
				setGameResultTime(getFinalTime(response.time));
				setGameTime(response.time);
				setCurrentGameId(response.gameid);
				if (response.time < 2) {
					setCanBet(false);
				}
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		getCurrentGameTime();
	}, [locationState.state.value, isTimerActive]);

	// Timer Logic
	useEffect(() => {
		let intervalId;
		if (isTimerActive) {
			intervalId = setInterval(() => {
				setGameTime((prevTime) => {
					if (prevTime <= 1) {
						clearInterval(intervalId);
						setIsTimerActive(false);
						setCanBet(false);
						setTimeout(() => {
							handleTimerReset();
						}, 1000);
						return 0;
					} else if (prevTime < 2) {
						setCanBet(false);
					}
					return Math.max(prevTime - 1, 0);
				});
			}, 1000);
		} else {
			clearInterval(intervalId);
		}
		return () => clearInterval(intervalId);
	}, [isTimerActive]);

	// Timer Reset Handler
	const handleTimerReset = () => {
		setIsTimerActive(true);
		setCanBet(true);
	};

	const handleSetMultiplier = async () => {
		const payload = {
			multiplier: selectedMultiplier,
		};
		try {
			const port = gamePorts[locationState.state.value];

			const response = await generalPostFunction("/setmultiplier", payload, port);
			if (response.message.includes("updated")) {
				toast.success("Multiplier updated successfully!");
				reset();
			}
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>
										Set Game Result
										<button className="clearButton" onClick={() => setRefresh(refresh + 1)}>
											<SvgIcon name="refresh" />
										</button>
									</h4>
									<p>Set the game result for specific game</p>
								</div>
								<div className="buttonGroup">
									<button type="submit" className="panelButton" onClick={handleSetResult} disabled={!canBet || !selectedCard}>
										<span className="text">Save</span>
										<span className="icon">
											<SvgIcon name="save" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ padding: "25px 23px" }}>
							<div className="row">
								<div className="col-xl-12 mb-3">
									<div className="defaultTable">
										<table>
											<tr>
												<td>
													<label className="fw-bold">Current Game: {gameResultTime}</label>
												</td>
												<td>
													<label className="fw-bold">Round Timer: {gameTime}</label>
												</td>
												<td>
													<label className="fw-bold">Total Playing: {(allBetData && allBetData.length) || 0}</label>
												</td>
												<td>
													<label className="fw-bold">Total Bet: {allBetData && allBetData.reduce((sum, item) => sum + (Number(item.totalbet) || 0), 0)}</label>
												</td>
											</tr>
										</table>
									</div>
								</div>
								<div className="col-xl-7">
									<div className="row gy-3">
										{locationState.state.value === "spin2win" ? (
											<>
												{Array.from({ length: 10 }, (_, i) => {
													const cardValue = `N${i}`;
													const playAmnt = allBetData.reduce((sum, item) => {
														const bets = JSON.parse(item.bets || "{}"); // parse bets JSON
														return sum + (Number(bets[cardValue]) || 0);
													}, 0);
													return (
														<div className="col-auto">
															<div key={i} className={`cardWrapper ${selectedCard == cardValue ? "selected" : ""}`} onClick={() => setSelectedCard(cardValue)}>
																<label>{playAmnt}</label>
																<img src={`/assets/images/games/spin2win/${cardValue}.png`} />
															</div>
														</div>
													);
												})}
											</>
										) : locationState.state.value === "joker12card" ? (
											<>
												{Array.from({ length: 12 }, (_, i) => {
													const cardValue = `N${i}`;
													const playAmnt = allBetData.reduce((sum, item) => {
														const bets = JSON.parse(item.bets || "{}"); // parse bets JSON
														return sum + (Number(bets[cardValue]) || 0);
													}, 0);
													return (
														<div className="col-3">
															<div key={i} className={`cardWrapper ${selectedCard == cardValue ? "selected" : ""}`} onClick={() => setSelectedCard(cardValue)}>
																<label className="cardGame">{playAmnt}</label>
																<img src={`/assets/images/games/joker12card/${cardArray.find((card) => card.nCardId == cardValue)?.name}.png`} />
															</div>
														</div>
													);
												})}
											</>
										) : locationState.state.value === "joker16card" ? (
											<>
												{Array.from({ length: 16 }, (_, i) => {
													const cardValue = `N${i}`;
													const playAmnt = allBetData.reduce((sum, item) => {
														const bets = JSON.parse(item.bets || "{}"); // parse bets JSON
														return sum + (Number(bets[cardValue]) || 0);
													}, 0);
													return (
														<div className="col-3">
															<div key={i} className={`cardWrapper ${selectedCard == cardValue ? "selected" : ""}`} onClick={() => setSelectedCard(cardValue)}>
																<label className="cardGame">{playAmnt}</label>
																<img src={`/assets/images/games/joker12card/${cardArray.find((card) => card.nCardId == cardValue)?.name}.png`} />
															</div>
														</div>
													);
												})}
											</>
										) : locationState.state.value === "triplechance" ? (
											<>
												{(() => {
													// Flatten & sum all bets
													const betTotals = {};

													allBetData.forEach((item) => {
														const bets = JSON.parse(item.bets || "{}");
														Object.entries(bets).forEach(([key, value]) => {
															betTotals[key] = (betTotals[key] || 0) + Number(value);
														});
													});

													// Create groups
													const single = [];
													const double = [];
													const triple = [];

													Object.entries(betTotals).forEach(([key, amount]) => {
														if (amount <= 0) return;

														// key format: N6, N07, N123, etc.
														const num = key.replace("N", "");

														if (num.length === 1)
															single.push({ key, amount }); // N0 - N9
														else if (num.length === 2)
															double.push({ key, amount }); // N00 - N99
														else if (num.length === 3) triple.push({ key, amount }); // N000 - N999
													});

													// Sort inside each category numerically
													const sortFn = (a, b) => Number(a.key.replace("N", "")) - Number(b.key.replace("N", ""));

													single.sort(sortFn);
													double.sort(sortFn);
													triple.sort(sortFn);

													return (
														<>
															{/* ---------------- SINGLE ---------------- */}
															<div className="col-12 mt-2">
																<div className="wrapper">
																	<div className="row gy-1">
																		{single.length > 0 && (
																			<div className="col-12">
																				<h5 className="fw-bold">Single</h5>
																			</div>
																		)}
																		{single.map(({ key, amount }) => (
																			<div className="col-auto" key={key}>
																				<div className={`triple cardWrapper ${selectedCard === key ? "selected" : ""}`} onClick={() => setSelectedCard(key)}>
																					<label className="cardNumber">{key.substring(1)}</label>
																					<label className="cardGame">{amount}</label>
																					<img src={`/assets/images/games/triplechance/selectedCard.png`} />
																				</div>
																			</div>
																		))}
																	</div>
																</div>
															</div>

															{/* ---------------- DOUBLE ---------------- */}
															<div className="col-12 mt-2">
																<div className="wrapper">
																	<div className="row gy-2">
																		{double.length > 0 && (
																			<div className="col-12 ">
																				<h5 className="fw-bold">Double</h5>
																			</div>
																		)}
																		{double.map(({ key, amount }) => (
																			<div className="col-auto" key={key}>
																				<div className={`triple cardWrapper ${selectedCard === key ? "selected" : ""}`} onClick={() => setSelectedCard(key)}>
																					<label className="cardNumber">{key.substring(1)}</label>
																					<label className="cardGame">{amount}</label>
																					<img src={`/assets/images/games/triplechance/selectedCard.png`} />
																				</div>
																			</div>
																		))}
																	</div>
																</div>
															</div>

															{/* ---------------- TRIPLE ---------------- */}
															<div className="col-12 mt-2">
																<div className="wrapper">
																	<div className="row gy-2">
																		{triple.length > 0 && (
																			<div className="col-12">
																				<h5 className="fw-bold">Triple</h5>
																			</div>
																		)}
																		{triple.map(({ key, amount }) => (
																			<div className="col-auto" key={key}>
																				<div className={`triple cardWrapper ${selectedCard === key ? "selected" : ""}`} onClick={() => setSelectedCard(key)}>
																					<label className="cardNumber">{key.substring(1)}</label>
																					<label className="cardGame">{amount}</label>
																					<img src={`/assets/images/games/triplechance/selectedCard.png`} />
																				</div>
																			</div>
																		))}
																	</div>
																</div>
															</div>
														</>
													);
												})()}
											</>
										) : (
											""
										)}
										<div className="col-xl-12">
											<div className="col-12">
												<div className="d-flex justify-content-between align-items-center">
													{Array.from({ length: 3 }, (_, i) => {
														const value = i + 1;
														return (
															<div className={`wheelMultiplier ${selectedMultiplier == value ? "selected" : ""}`} onClick={() => setSelectedMultiplier(value)}>
																<label>{value == 1 ? "N" : value}</label>
															</div>
														);
													})}
													<div>
														<button type="button" className="panelButton static w-100" onClick={handleSetMultiplier} disabled={!canBet}>
															<span className="text">Set Multiplier</span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-5">
									<PlayerBetsByGameID
										tableType={"betInfo"}
										currentGameId={currentGameId}
										currentGame={locationState.state.value}
										refresh={refresh}
										setRefresh={setRefresh}
										loading={loading}
										setLoading={setLoading}
										rawData={allBetData}
										setRawData={setAllBetData}
									/>
								</div>
								<div className="col-xl-12">
									<PlayerBetsByGameID
										tableType={"allInfo"}
										currentGameId={currentGameId}
										currentGame={locationState.state.value}
										refresh={refresh}
										setRefresh={setRefresh}
										loading={loading}
										setLoading={setLoading}
										rawData={allBetData}
										setRawData={setAllBetData}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default SetGameResult;

export function PlayerBetsByGameID({ tableType, currentGameId, currentGame, refresh, setRefresh, loading, setLoading, rawData, setRawData }) {
	const allPlayerBet = useSelector((state) => state.allPlayers.allPlayerBet);

	const getHistoryByPlayer = async () => {
		setLoading(true);
		const payload = {
			gameid: currentGameId,
			gamename: gameCollectionArray.find((item) => item.value == currentGame).api,
		};

		try {
			const response = await generalPostFunction("/getticketsplacedbygameid", payload, "3040");
			if (response.length > 0) {
				setRawData(response);
			}
		} catch (err) {
			console.log();
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		// let interval;

		if (currentGameId) {
			getHistoryByPlayer();

			// interval = setInterval(() => {
			//   getHistoryByPlayer();
			// }, 5000);
		}

		// return () => {
		//   if (interval) clearInterval(interval);
		// };
	}, [currentGameId, refresh, currentGame]);

	// Descending sort by total bets
	const sortedData = [...rawData].sort((a, b) => b.total - a.total);

	useEffect(() => {
		if (allPlayerBet && allPlayerBet.length > 0) {
			setRefresh((prev) => prev + 1);
		}
	}, [allPlayerBet]);

	return (
		<>
			{tableType == "allInfo" && (
				<div className="tableContainer">
					{(() => {
						const numberKeys = Object.keys(rawData[0] || {}).filter((key) => key.startsWith("N"));

						// sort numberKeys if you want them in order like N0, N1, N2...
						numberKeys.sort((a, b) => {
							const numA = parseInt(a.slice(1));
							const numB = parseInt(b.slice(1));
							return numA - numB;
						});
						return (
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Username</th>
										<th>Bets</th>
										{/* <th>Total Bet</th> */}
										{/* Dynamic number columns */}
										{/* {numberKeys.map((key) =>
                      currentGame === "spin2win" ? (
                        <th key={key}>{key.slice(1)}</th>
                      ) : currentGame === "joker12card" || currentGame === "joker16card" ? (
                        <th key={key}>{cardArray.find((card) => card.nCardId == key)?.name}</th>
                      ) : (
                        ""
                      )
                    )} */}
										<th>Total Won</th>
										<th>Status</th>
										<th>Date</th>
										<th>Time</th>
									</tr>
								</thead>
								<tbody>
									{sortedData && sortedData.length > 0 ? (
										sortedData.map((item, index) => {
											const betItems = JSON.parse(item.bets);
											return (
												<tr key={index}>
													<td>{index + 1}</td>
													<td>{item.username}</td>
													{/* <td>
                            {Object.entries(betItems).map(([key, value]) => (
                              <span key={key}>
                                <b>{key.substring(1)}</b>: {value},{" "}
                              </span>
                            ))}
                          </td> */}
													<td>{item.totalbet || 0}</td>
													{/* Dynamic number column values */}
													{/* {numberKeys.map((key) => (
                          <td key={key}>{item[key] || 0}</td>
                        ))} */}
													<td>{item.winamount || 0}</td>
													<td>{item.status || "N/A"}</td>
													<td>{item.result_date.split("T")[0]}</td>
													<td>{convertTimeToAMPM(item.result_time)}</td>
												</tr>
											);
										})
									) : (
										<tr>
											<td colSpan={99}>No Bets Placed</td>
										</tr>
									)}
								</tbody>
							</table>
						);
					})()}
				</div>
			)}
			{tableType == "betInfo" && (
				<div className="tableContainer mt-0" style={{ maxHeight: "440px" }}>
					<table>
						<thead>
							<tr>
								<th>Name</th>
								<th>Play Amount</th>
								<th>Win Amount</th>
							</tr>
						</thead>
						{currentGame !== "triplechance" ? (
							<tbody>
								{(() => {
									const playAmounts = Array.from(
										{
											length: currentGame == "spin2win" ? 10 : currentGame == "joker12card" ? 12 : currentGame == "joker16card" ? 16 : 10,
										},
										(_, i) => {
											const cardValue = `N${i}`;

											const playAmnt = rawData.reduce((sum, item) => {
												const bets = JSON.parse(item.bets || "{}"); // 👈 parse the bets JSON
												return sum + (Number(bets[cardValue]) || 0);
											}, 0);

											return { number: i, playAmnt, cardValue };
										},
									);

									// sort descending
									playAmounts.sort((a, b) => b.playAmnt - a.playAmnt);

									return playAmounts.map(({ number, playAmnt, cardValue }) => (
										<tr key={number}>
											<td className="fw-bold">
												{currentGame == "spin2win"
													? cardValue.substring(1)
													: currentGame == "joker12card" || currentGame == "joker16card"
														? cardArray.find((item) => item.nCardId == cardValue)?.name || cardValue
														: ""}
											</td>
											<td>{playAmnt}</td>
											<td>{playAmnt * Number(gamePayRates[currentGame]) || 0}</td>
										</tr>
									));
								})()}
							</tbody>
						) : (
							<tbody>
								{(() => {
									// Helper to compute summed amounts
									const getPlayAmount = (key) => {
										return rawData.reduce((sum, item) => {
											const bets = JSON.parse(item.bets || "{}");
											return sum + (Number(bets[key]) || 0);
										}, 0);
									};

									// --- SINGLE (N0 - N9) ---
									const single = Array.from({ length: 10 }, (_, i) => {
										const key = `N${i}`;
										return { label: i, key, amount: getPlayAmount(key) };
									});

									// --- DOUBLE (N00 - N99) ---
									const double = Array.from({ length: 100 }, (_, i) => {
										const key = `N${String(i).padStart(2, "0")}`;
										return { label: String(i).padStart(2, "0"), key, amount: getPlayAmount(key) };
									});

									// --- TRIPLE (N000 - N999) ---
									const triple = Array.from({ length: 1000 }, (_, i) => {
										const key = `N${String(i).padStart(3, "0")}`;
										return { label: String(i).padStart(3, "0"), key, amount: getPlayAmount(key) };
									});

									return (
										<>
											{/* ---------------- SINGLE ---------------- */}
											<tr>
												<td colSpan={3} className="fw-bold bg-light">
													Single
												</td>
											</tr>
											{single
												.sort((a, b) => b.amount - a.amount)
												.map(({ label, amount }) => (
													<tr key={label}>
														<td>{label}</td>
														<td>{amount}</td>
														<td>{amount * 9}</td>
													</tr>
												))}

											{/* ---------------- DOUBLE ---------------- */}
											<tr>
												<td colSpan={3} className="fw-bold bg-light">
													Double
												</td>
											</tr>
											{double
												.sort((a, b) => b.amount - a.amount)
												.map(({ label, amount }) => (
													<tr key={label}>
														<td>{label}</td>
														<td>{amount}</td>
														<td>{amount * 90}</td>
													</tr>
												))}

											{/* ---------------- TRIPLE ---------------- */}
											<tr>
												<td colSpan={3} className="fw-bold bg-light">
													Triple
												</td>
											</tr>
											{triple
												.sort((a, b) => b.amount - a.amount)
												.map(({ label, amount }) => (
													<tr key={label}>
														<td>{label}</td>
														<td>{amount}</td>
														<td>{amount * 900}</td>
													</tr>
												))}
										</>
									);
								})()}
							</tbody>
						)}
					</table>
				</div>
			)}
		</>
	);
}
